import { useMutation, useReactiveVar } from '@apollo/client';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import FormChoice from '../../../components/FormChoice/FormChoice';
import { FORM_CHOICE_COMPONENT_TYPES, FORM_CHOICE_TYPES } from '../../../components/FormChoice/types';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import { AnalyticsEvents, trackEvent } from '../../../utils/analytics';
import { CreateNewPet, EditPetRecord } from '../../../utils/queries';

const FormPetNeutred = () => {
  const { t } = useTranslation();
  const type = FORM_CHOICE_TYPES.NEUTRED;
  const { register, control, reset, setValue } = useForm();
  const newPet = useReactiveVar(vars.newPet);
  const { registerAs } = FORM_CHOICE_COMPONENT_TYPES[type];
  const petNeutred = newPet.gender === 'MALE' ? t('neutred') : t('spayed');
  const title = t(FORM_CHOICE_COMPONENT_TYPES[type]?.title, {
    petName: newPet.name,
    petNeutred
  });

  const formAnswer = useWatch({ name: `choice_${registerAs}`, control });
  const [createPet, { loading, error, data }] = useMutation(CreateNewPet);
  const [editPetRecord, { loading: petRecordLoading, data: petRecordData }] = useMutation(EditPetRecord);

  useEffect(() => {
    if (formAnswer) {
      vars.newPet({ ...newPet, neutred: formAnswer === 'true' });

      trackEvent(AnalyticsEvents.PET_CREATED);

      createPet({
        variables: {
          name: newPet.name,
          type: newPet.type,
          breed: newPet.breed,
          gender: newPet.gender,
          birthdate: newPet.birthday
        }
      });
    }
  }, [formAnswer]);

  useEffect(() => {
    if (data) {
      editPetRecord({
        variables: {
          id: data.petAdd.PetRecord.id,
          neutred: newPet.neutred
        }
      });
    }
  }, [data]);

  useEffect(() => {
    if (petRecordData) {
      increaseFormPage();
    }
  }, [petRecordData]);

  return <FormChoice type={type} formOptions={{ register, reset, setValue }} title={title} loading={loading || petRecordLoading} />;
};

export default FormPetNeutred;
